export const APP_VERSION = '1.66.0';
